<template id="map-template">
  <div class="homeview-fast-track-entrance">
    <div class="header">
      <span class="header-title">快速入口</span>
      <div class="arrow-pic"></div>
    </div>
    <div class="table-chart">
      <div class="fask-track-entrance-list">
        <div
          class="list-item"
          v-for="item in shortcuts"
          :key="item.Extend1"
          @click="handleClick(item.Extend2)"
        >
          <i class="el-icon-share"></i>
          <span>{{ item.Extend1 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";

export default {
  name: "HomeViewFastTrackEntrance",
  componentName: "HomeViewFastTrackEntrance",
  components: {},
  props: {},
  data() {
    return {
      shortcuts: [],
    };
  },
  methods: {
    search() {
      let that = this;
      let searchInfo = {
        SysCode: "HomeView",
        Key: "Shortcut",
      };
      new MyApis.UniformConfigApi()
        .GetConfigItemsListExt(searchInfo)
        .then((r) => {
          r = r.data.Data;
          console.log(r);
          this.shortcuts = r;
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    handleClick(url) {
      if (url) {
        if (url.includes("http")) {
          window.open(url);
        } else {
          this.$router.push({
            path: url,
            query: {},
          });

          // eslint-disable-next-line no-undef
          $(".zj-app").removeClass("zj-emergencyoperations-map");
        }
      } else {
        this.$message({
          type: "warning",
          message: "快速入口菜单地址未配置",
        });
      }
    },
  },
  created() {
    this.search();
  },
  mounted() {},
};
</script>